import { CheckCircleIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { LineageNode } from "@/features/FileManagement/fileManagement.types";

export function LineageNodeItem({
    node,
    children,
    isLast = false,
    level = 0,
}: {
    node: LineageNode;
    children?: React.ReactNode;
    isLast?: boolean;
    frontDash?: boolean;
    level?: number;
}) {
    return (
        <li
            key={node.id}
            className={clsx("relative flex flex-col gap-1", isLast && "pb-4")}
        >
            {!isLast && (
                <div
                    className={clsx(
                        "w-0.5",
                        "absolute  rounded",
                        level === 0
                            ? "-bottom-6 left-[0.45rem] top-6 bg-slate-600"
                            : `-bottom-6 left-[7px] top-6 bg-slate-400`,
                    )}
                />
            )}

            {/* {frontDash && (
                <div
                    className={clsx(
                        "absolute left-[-14px] top-3 h-0.5 w-2 rounded",
                        "bg-slate-500",
                    )}
                />
            )} */}

            <div className="flex items-start justify-between gap-4">
                <div className="flex items-start gap-3">
                    <div className="relative z-10 mt-1">
                        {node.status === "completed" && (
                            <CheckCircleIcon className="size-4" />
                        )}
                        {node.status === "in-progress" && (
                            <div
                                className={clsx(
                                    "mt-1",
                                    "ring-2 ",
                                    "ml-1 size-2 rounded-full",
                                    level === 0
                                        ? "ring-slate-600"
                                        : "ring-slate-500",
                                )}
                            />
                        )}
                    </div>
                    <p className="subdued">
                        <strong className="text-default">
                            {node.emphasizedText}
                        </strong>
                        {node.emphasizedText && " "}
                        {node.text}
                    </p>
                </div>
                {node.date && (
                    <p className="body-s mt-px text-gray-500">{node.date}</p>
                )}
            </div>
            {node.link && (
                <Link to={node.link.href} className="ml-7">
                    {node.link.label}
                </Link>
            )}
            {children}
        </li>
    );
}
